import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { Button } from '@uhg-abyss/web/ui/Button';

const StyledSearchContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: '16px',
  padding: '0px 15px 16px 15px',
});

const StyledTooltip = styled(Tooltip, {
  '&.abyss-tooltip-content': {
    width: '225px',
    textAlign: 'center',
    zIndex: 999999,
  },
});

const StyledTextInput = styled(TextInput, {
  fontSize: '14px',
});

export const PayerTableSearch = ({
  payerNameSearchValue,
  setPayerNameSearchValue,
  payerIdSearchValue,
  setPayerIdSearchValue,
}) => {
  return (
    <StyledSearchContainer>
      <StyledTextInput
        isClearable
        onClear={() => setPayerNameSearchValue('')}
        placeholder="Filter by name"
        label="Name"
        value={payerNameSearchValue}
        onChange={(e) => setPayerNameSearchValue(e.target.value)}
        data-testid="payer-select-name-search"
      />
      <StyledTextInput
        isClearable
        onClear={() => setPayerIdSearchValue('')}
        placeholder="Filter by Payer ID"
        label="Payer ID"
        value={payerIdSearchValue}
        onChange={(e) => setPayerIdSearchValue(e.target.value)}
        data-testid="payer-select-id-search"
        width="50%"
        helper={
          <StyledTooltip
            title="Custom Helper"
            content="Locate the Payer ID on the front of the member's health insurance card."
            position="top"
          >
            <Button rounded variant="ghost" size="$xs">
              <IconMaterial icon="info" size={18} />
            </Button>
          </StyledTooltip>
        }
      />
    </StyledSearchContainer>
  );
};

PayerTableSearch.propTypes = {
  payerNameSearchValue: PropTypes.string.isRequired,
  setPayerNameSearchValue: PropTypes.func.isRequired,
  payerIdSearchValue: PropTypes.string.isRequired,
  setPayerIdSearchValue: PropTypes.func.isRequired,
};
